import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactPlaceholder from 'react-placeholder'
import HasPhonePlaceholder from './HasPhonePlaceholder'
import { Icon, Button } from 'loyal-react'
import { ModalDeleteItem } from '../ModalDeleteItem/index'

class HasPhone extends Component {
  state = {
    showDeleteConfirmation: false
  }

  deleteConfirmation = () => {
    this.setState({
      showDeleteConfirmation: true
    })
  }

  render () {
    return (
      <ReactPlaceholder
        ready={!this.props.isLoading}
        customPlaceholder={<HasPhonePlaceholder />}
      >
        <div className='col-12 row mx-0 px-0'>
          <div className='col-12 border-bottom border-color-ui-3 px-0 pb-2'>
            <p className='txt-body-sm'>O seu celular validado será utilizado para confirmar os resgates no catálogo de prêmios​.</p>
          </div>
          <div className='row col-12 border-bottom border-color-ui-3 mx-0 px-0 py-2'>
            <div className='col-auto d-flex align-items-center'>
              <Icon
                className='icon icon_phone'
              />
            </div>
            <div className='col ml-1'>
              <p className='txt-body-sm'>Adicionado em 24/07/2019 - 12:20</p>
              <p className='txt-body txt-bold'>Celular: (**) *****932</p>
            </div>
            <div className='col-auto d-flex align-items-center'>
              <Icon
                className='icon icon_trash pointer txt-body'
                onClick={() => this.deleteConfirmation()}
              />
            </div>
          </div>
          <div className='row col-12 border-bottom border-color-ui-3 mx-0 px-0 py-2'>
            <div className='col-auto d-flex align-items-center'>
              <Icon
                className='icon icon_newsletter'
              />
            </div>
            <div className='col'>
              <p className='txt-body-sm'>Adicionado em 24/07/2019 - 12:20</p>
              <p className='txt-body txt-bold'>E-mail: nome*****@**ail.com</p>
            </div>
            <div className='col-auto d-flex align-items-center'>
              <Icon
                className='icon icon_trash pointer txt-body'
                onClick={() => this.deleteConfirmation()}
              />
            </div>
          </div>
          <div className='col-12 row mx-0 px-0 justify-content-end'>
            <div className='col-12 col-md-3 px-0 pt-3 pb-2'>
              <Button
                className='btn btn-sm btn-featured txt-button txt-center txt-font-body-bold'
                text='Alterar celular'
                onClick={() => {}}
              />
            </div>
          </div>
          <ModalDeleteItem
            show={this.state.showDeleteConfirmation}
            onCloseButton={e => this.setState({ showDeleteConfirmation: false })}
            onClose={e => this.setState({ showDeleteConfirmation: false })}
          />
        </div>
      </ReactPlaceholder>
    )
  }
}

HasPhone.propTypes = {
  isLoading: PropTypes.bool
}

export default HasPhone



// WEBPACK FOOTER //
// ./src/Participant/TwoStepVerification/HasPhone/HasPhone.js